import { ExternalScript } from '../store/config/config.reducer';

const CWV_SITE_SAMPLING_RATES: Record<string, number> = {
  'fansided.com': 40,
  'www.si.com': 25,
};

export function getCWVScript(canonicalURL: string): ExternalScript | null {
  let samplePercentage = 0;

  try {
    const url = new URL(canonicalURL);
    const { hostname } = url;

    samplePercentage = CWV_SITE_SAMPLING_RATES[hostname] ?? 50;
  } catch (error) {
    return null;
  }

  if (samplePercentage > 0) {
    return {
      type: 'code',
      source: `
          (function () {
            const SAMPLE_PERCENTAGE = ${samplePercentage};
            if (Math.random() < SAMPLE_PERCENTAGE / 100) {
              const script = document.createElement("script");
              script.src =
                "https://assets.minutemediacdn.com/mm-cwv-tracker/prod/mm-cwv-tracker.js";
              script.async = true;
              document.head.appendChild(script);
            }
          })();
        `,
      name: 'cwv-tracker',
      attributes: null,
      loadingType: 'async',
    };
  }

  return null;
}
